import validator from "validator";
import { cloneDeep } from "lodash";

// Const
import { defaultAllItem, defaultSyslogServerState } from "../../const";

const getDefaultSyslogServerState = (defaultSyslogServerState) => {
  const syslogServerState = cloneDeep(defaultSyslogServerState);

  syslogServerState.port.valid = true;
  syslogServerState.protocol.list = [
    { title: 'UDP', value: 'UDP', isActive: false },
    { title: 'TCP', value: 'TCP', isActive: false }
  ];

  return syslogServerState;
}

const getSyslogServerState = (selectedSyslogServer, remainingSiteList, managedSiteList) => {
  const syslogServerState = getDefaultSyslogServerState(defaultSyslogServerState, remainingSiteList);

  syslogServerState.site.list.push(cloneDeep(defaultAllItem));
  for (const site of remainingSiteList) {
    syslogServerState.site.list.push({
      id: site.id,
      title: site.name,
      checked: false
    })
  }

  if (!selectedSyslogServer) {
    syslogServerState.protocol.list[0].isActive = true;
    syslogServerState.protocol.selected = syslogServerState.protocol.list[0];

    syslogServerState.site.list.length === 1 && (syslogServerState.site.list[0].checked = true);

    return syslogServerState;
  }

  syslogServerState.name.value = selectedSyslogServer.rawData.name;
  syslogServerState.name.valid = true;

  syslogServerState.server.value = selectedSyslogServer.rawData.host;
  syslogServerState.server.valid = true;

  syslogServerState.port.value = selectedSyslogServer.rawData.port;
  syslogServerState.port.valid = true;

  if (selectedSyslogServer.rawData.protocol === syslogServerState.protocol.list[0].value) {
    syslogServerState.protocol.list[0].isActive = true;
    syslogServerState.protocol.selected = syslogServerState.protocol.list[0];
  } else {
    syslogServerState.protocol.list[1].isActive = true;
    syslogServerState.protocol.selected = syslogServerState.protocol.list[1];
  }

  if (selectedSyslogServer.rawData.storeIds.length > 0) {
    syslogServerState.site.list = syslogServerState.site.list.slice(0, 1);
    syslogServerState.site.list[0].checked = true;

    for (const siteId of selectedSyslogServer.rawData.storeIds) {
      for (const site of managedSiteList) {
        if (siteId === site.id) {
          syslogServerState.site.list.push({
            id: siteId,
            title: site.name,
            checked: true
          });
        }
      }
    }
  }

  return syslogServerState;
}

const changeName = (name, value) => {
  name.value = value;
  name.dirty = true;
  name.valid = name.required && validator.isByteLength(value, { min: name.minLength, max: name.maxLength });
}

const changeServer = (server, value) => {
  server.value = value;
  server.dirty = true;
  server.valid = (!server.required || server.regex.test(value)) ? true : false;
}

const changePort = (port, value) => {
  port.value = value;
  port.dirty = true;
  port.valid = (!port.required || validator.isFloat(value, { min: port.min, max: port.max })) ? true : false;
}

const changeProtocol = (protocol, value) => {
  for (const item of protocol.list) {
    item.isActive = false;
    item.value === value.value && (item.isActive = true);
  }

  protocol.selected = value;
}

const changeSite = (site, item) => {
  if (item.id === 0) {
    if (site.list.length === 1) {
      return;
    }

    const newState = !item.checked;
    for (const _site of site.list) {
      _site.checked = newState;
    }

    site.valid = !item.checked;
  } else {
    for (const _site of site.list) {
      (_site.id === item.id) && (_site.checked = !_site.checked);
    }

    site.list[0].checked = true;
    for (const _site of site.list) {
      (!_site.checked) && (site.list[0].checked = false);
      _site.checked && (site.valid = true);
    }
  }
}

export default {
  getSyslogServerState,
  changeName,
  changeServer,
  changePort,
  changeProtocol,
  changeSite
};